import request from '@/helper/request'

// 删除咨询产品
export function delInquiry(id) {
  const data = {
    req: {
      ids: id
    }
  }
  return request({
    url: '/json/inquiry/delete',
    method: 'post',
    data: data
  })
}

//添加商品到咨询
export function addInquiry(data) {
  return request({
    url: '/json/inquiry/add',
    method: 'post',
    data: data
  })
}

//修改咨询内产品数量
export function editInquiry(id, newValue) {
  const editReq = {
    req: {
      id: id,
      info: {
        number: newValue
      }
    }
  }
  return request({
    url: '/json/inquiry/edit',
    method: 'post',
    data: editReq
  })
}

//查询指定咨询信息
export function readInquiry() {
  const data = {}
  return request({
    url: '/json/inquiry/read',
    method: 'post',
    data: data
  })
}

//  查询咨询模型字段数据
export function fieldsInquiry() {
  const data = {}
  return request({
    url: '/json/inquiry/read',
    method: 'post',
    data: data
  })
}

//列表分页及搜索
export function Inquirylist(data) {
  return request({
    url: '/json/inquiry/list',
    method: 'post',
    data: data
  })
}

//咨询数量变化
export function InquiryCountChange(data) {
  return request({
    url: '/json/inquiry/edit',
    method: 'post',
    data: data
  })
}

// 提交产品咨询订单
export function placeInquiry(data) {
  return request({
    url: "/json/inquiry/placeInquiry",
    method: "post",
    data: data
  });
}

// 获取产品咨询订单列表
export function inquiryList(data) {
  return request({
    url: "/json/inquiry/inquiryList",
    method: "post",
    data: data
  });
}

// 获取产品详情
export function inquiryRead(data) {
  return request({
    url: "/json/inquiry/inquiryRead",
    method: "post",
    data: data
  });
}
